import React, { useState } from 'react';
import { AppShell, Burger, Container, Flex, Title } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LeftNavMenu } from './components/LeftNavMenu';
import { FamilyTree } from './components/familyTree/FamilyTree';
import { Gallery } from './components/gallery/Gallery';
import { IdentifyFaces } from './components/identifyFaces/IdentifyFaces';
import { GroupImagesManually } from './components/sortImages/GroupImagesManually';
import { DeleteDuplicates } from './components/removeDuplicates/DeleteDuplicates';
import { FileUploader } from './components/FileUploader';
import { Settings } from './components/settings/Settings';
import { UserMenu } from './UserDropdown';
import { useAuth } from './UseAuthHook';
import ImageDetails from './components/gallery/ImageDetails';
import { useNavigate } from 'react-router-dom';
import './logo-font.css';

export const Logo = () => {
    const isMobile = useMediaQuery('(max-width: 768px)');
    // Reduced logo height for the shorter header
    const logoHeight = isMobile ? 24 : 36;
    // Smaller font size for the shorter header
    const titleFontSize = isMobile ? 24 : 36;
    
    return (
        <Flex align="center">
            <img
                src="/logo.png"
                alt="Company Logo"
                style={{
                    height: logoHeight,
                    marginRight: isMobile ? 8 : 15,
                    marginTop: -10 // Reduced top margin
                }}
            />
            <Title
                c="black"
                order={1}
                style={{
                    fontFamily: 'Bebas Neue',
                    fontSize: titleFontSize,
                    whiteSpace: 'nowrap',
                }}
            >
                SORT MY SHOEBOX
            </Title>
        </Flex>
    );
};

export function AuthenticatedLayout() {
    const [opened, setOpened] = useState(false);
    const extraPadding = useMediaQuery('(min-width: 1440px)');
    const navigate = useNavigate();
    const location = window.location.pathname;
    const isImageView = location.match(/^\/gallery\/[^\/]+\/[^\/]+$/);

    const toggle = () => setOpened((o) => !o);

    if (isImageView) {
        return (
            <Routes>
                <Route path="/gallery/:userSub/:imageKey"
                    element={<ImageDetails
                        onClose={() => {
                            console.log("Closing image inspector");
                            navigate('/gallery');
                        }}
                    />}
                />
            </Routes>
        );
    }

    return (
        <AppShell
            header={{ height: 85 }}
            navbar={{
                width: { base: '100%', sm: '300px' },
                breakpoint: 'sm',
                collapsed: { mobile: !opened },
            }}
            padding="md"
        >
            <AppShell.Header>
                <Container size="100%" h="100%">
                    <Flex justify="space-between" align="center" h="100%" ml={extraPadding ? '10vw' : '10px'} mr={extraPadding ? '10vw' : '10px'}>
                        <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
                        <Logo />
                        <UserMenu/>
                    </Flex>
                </Container>
            </AppShell.Header>

            <AppShell.Navbar p="md" style={{ marginLeft: extraPadding ? '10vw' : '10px', borderRight: '1px solid #ccc' }}>
                <Flex direction="column" style={{ height: '100%', justifyContent: 'flex-start', alignItems: 'flex-end' }}>
                    <LeftNavMenu />
                </Flex>
            </AppShell.Navbar>

            <AppShell.Main>
                <Container size="100%" style={{ marginLeft: extraPadding ? '10vw' : '10px', marginRight: extraPadding ? '10vw' : '10px' }}>
                    <Routes>
                        <Route path="/gallery" element={<Gallery />} />
                        <Route path="/family-tree" element={<FamilyTree />} />
                        <Route path="/identify-faces" element={<IdentifyFaces />} />
                        <Route path="/sort-images" element={<GroupImagesManually />} />
                        <Route path="/remove-duplicates" element={<DeleteDuplicates />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/import" element={<FileUploader />} />
                        <Route path="/" element={<Navigate to="/gallery"/>} />
                    </Routes>
                </Container>
            </AppShell.Main>
        </AppShell>
    );
}
